export const MIN_PHONE_LENGTH = 8;
export const MAX_PHONE_LENGTH = 14;
export const RUSSIAN_PHONE_LENGTH = 11;

export function removeAllNonDigits(value: string) {
	return value.replaceAll(/[^\d]/g, '');
}

export function isRussianNumber(phone: string): boolean {
	return /^\+7/.test(phone);
}

export function isValid(phone: string) {
	const length = digitsLength(phone);

	if (isRussianNumber(phone)) return length === RUSSIAN_PHONE_LENGTH;

	return length >= MIN_PHONE_LENGTH && length <= MAX_PHONE_LENGTH;
}

export function format(phone: string, pattern = '+# ### ###-##-##') {
	let value = removeAllNonDigits(phone);

	if (value.charAt(0) === '8' && isValid(value)) {
		value = '7' + value.slice(1);
	}

	if (value.charAt(0) !== '7') {
		return phone;
	}

	let i = 0;

	return pattern.replace(/#/g, () => value[i++] || '');
}

export function sanitize(value: string): string {
	return `+${removeAllNonDigits(value)}`;
}

export function digitsLength(value: string): number {
	return removeAllNonDigits(value).length;
}

export const phone = {
	removeAllNonDigits,
	isRussianNumber,
	isValid,
	format,
	sanitize,
	digitsLength,
};
